/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type HubPatientJourney_Patient = {
    readonly _id: string;
    readonly name: string | null;
    readonly firstname: string | null;
    readonly lastname: string | null;
    readonly master: boolean | null;
    readonly dateOfBirth: {
        readonly day: number | null;
        readonly month: number | null;
        readonly year: number | null;
    } | null;
    readonly " $refType": "HubPatientJourney_Patient";
};
export type HubPatientJourney_Patient$data = HubPatientJourney_Patient;
export type HubPatientJourney_Patient$key = {
    readonly " $data"?: HubPatientJourney_Patient$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HubPatientJourney_Patient">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HubPatientJourney_Patient",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "_id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "master",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PatientDateOfBirth",
      "kind": "LinkedField",
      "name": "dateOfBirth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "day",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "month",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "year",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Patient",
  "abstractKey": null
};
(node as any).hash = 'ebf928057ab82835624668e561f840ab';
export default node;
